import { render, staticRenderFns } from "./JsonEditor.vue?vue&type=template&id=21924162&scoped=true"
import script from "./JsonEditor.js?vue&type=script&lang=js&external"
export * from "./JsonEditor.js?vue&type=script&lang=js&external"
import style0 from "./JsonEditor.vue?vue&type=style&index=0&id=21924162&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21924162",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VIcon,VTreeview})
